module.exports = "/_next/static/images/main-4-a2773b06a2d7ae87cae9e18b2a7b478c.webp";